import React from 'react';
import PropTypes from 'prop-types';
import { getMatchReasons } from './Validations';

const DuplicateWarning = ({ duplicates, onNavigate, onMerge }) => {
  if (!duplicates || duplicates.length === 0) {
    return null;
  }

  const handleNavigate = (clientId, e) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate(clientId);
    }
  };

  const handleMerge = (duplicate, e) => {
    e.preventDefault();
    if (onMerge) {
      onMerge(duplicate);
    }
  };

  return (
    <div className="alert alert-warning mt-3" role="alert">
      <strong>Uwaga:</strong> Wykryto {duplicates.length}
      {duplicates.length === 1 ? ' potencjalny duplikat' : duplicates.length < 5 ? ' potencjalne duplikaty' : ' potencjalnych duplikatów'}:
      <ul className="mb-0 mt-2">
        {duplicates.map((duplicate) => {
          const reasons = getMatchReasons(duplicate);
          const reasonsText = reasons.join(', ');

          return (
            <li key={duplicate.id} className="d-flex justify-content-between align-items-center">
              <span>
                <a
                  href={`#/manage/client/${duplicate.id}`}
                  className="alert-link"
                  onClick={(e) => handleNavigate(duplicate.id, e)}
                >
                  {duplicate.firstName} {duplicate.lastName}
                </a>
                {reasonsText && ` (dopasowanie: ${reasonsText})`}
              </span>
              {onMerge && (
                <span className="ms-2">
                  <button
                    type="button"
                    className="btn btn-primary fw-bold ms-2"
                    onClick={(e) => handleMerge(duplicate, e)}
                  >
                    Scal
                  </button>
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

DuplicateWarning.propTypes = {
  duplicates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      matchReasons: PropTypes.arrayOf(PropTypes.string),
      matchReason: PropTypes.string, // Legacy format support
    })
  ).isRequired,
  onNavigate: PropTypes.func,
  onMerge: PropTypes.func,
};

DuplicateWarning.defaultProps = {
  onNavigate: null,
  onMerge: null,
};

export default DuplicateWarning;
